import React, { ReactNode } from 'react';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { zIndex } from '../../styles/zIndex';
import { cn } from '../../lib/cn';

interface SheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Edge the panel slides in from. */
  side?: 'left' | 'right';
  /** Panel width (px). */
  width?: number;
  /** Accessible name for the panel (visually hidden). */
  title: string;
  children: ReactNode;
}

/**
 * Slide-in side panel on Radix Dialog: real focus trap, Escape/overlay close,
 * scroll lock, aria wiring — the overlay class BaseUI's Drawer kept shipping
 * bugs in (SAM-169/173). Plain CSS transforms, no rAF-driven visibility.
 */
export const Sheet: React.FC<SheetProps> = ({
  open,
  onOpenChange,
  side = 'left',
  width = 240,
  title,
  children,
}) => {
  return (
    <DialogPrimitive.Root open={open} onOpenChange={onOpenChange}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay
          className="sheet-overlay fixed inset-0 bg-black/40"
          style={{ zIndex: zIndex.drawer }}
        />
        <DialogPrimitive.Content
          className={cn(
            'sheet-panel fixed top-0 h-full bg-white shadow-2 outline-none flex',
            side === 'left' ? 'left-0' : 'right-0 sheet-panel--right',
          )}
          style={{ width: `${width}px`, zIndex: zIndex.drawer + 1 }}
        >
          <DialogPrimitive.Title className="sr-only">{title}</DialogPrimitive.Title>
          {children}
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
};
